module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/.store/normalize-wheel@1.0.1/~/normalize-wheel/index.js
// module id = 196
// module chunks = 0